export function Footer() {
    return(
        <footer>
            <center>
                <p id="footercontent">© 2023 Seyong Ahn. All rights reserved.</p>
            </center>
        </footer>
    )
}